import React from "react";
import { Typography, Paper, Grid } from "@mui/material";
import FormTextField from "./FormTextField";
import { ExpertFormState } from "../../Models/expert";
import { useTranslation } from "react-i18next";
import colors from "../../Constants/colors";
import { useWorkspaceColors } from "../../Contexts/WorkspaceColorContext";

interface ValidationErrors {
  professionalBackground?: string;
  keyExpertise?: string;
  trainingAndCertifications?: string;
  processMastery?: string;
}

interface SkillsAndAbilitiesProps {
  formState: ExpertFormState;
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  validationErrors: ValidationErrors;
}

const SkillsAndAbilities: React.FC<SkillsAndAbilitiesProps> = ({
  formState,
  handleChange,
  validationErrors,
}) => {
  const { t } = useTranslation("expertForm");
  const { colors: workspace } = useWorkspaceColors();
  return (
    <Grid item xs={12}>
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 3,
          borderRadius: 2,
          border: `1px solid ${colors.gray200}`,
          borderLeft: `4px solid ${workspace.primary_dark}`,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            color: workspace.primary_dark,
            fontWeight: 600,
          }}
        >
          {t("expertForm.skillsAndAbilities")}
        </Typography>
        <FormTextField
          label={t("expertForm.professionalBackground")}
          name="professionalBackground"
          value={formState.professionalBackground}
          onChange={handleChange}
          info={t("expertForm.professionalBackgroundInfo")}
          minRows={1}
          error={!!validationErrors.professionalBackground}
          helperText={validationErrors.professionalBackground}
        />
        <FormTextField
          label={t("expertForm.keyExpertise")}
          name="keyExpertise"
          value={formState.keyExpertise}
          onChange={handleChange}
          info={t("expertForm.keyExpertiseInfo")}
          minRows={1}
          error={!!validationErrors.keyExpertise}
          helperText={validationErrors.keyExpertise}
        />
        <FormTextField
          label={t("expertForm.trainingAndCertifications")}
          name="trainingAndCertifications"
          value={formState.trainingAndCertifications}
          onChange={handleChange}
          info={t("expertForm.trainingAndCertificationsInfo")}
          minRows={1}
          error={!!validationErrors.trainingAndCertifications}
          helperText={validationErrors.trainingAndCertifications}
        />
        <FormTextField
          label={t("expertForm.processMastery")}
          name="processMastery"
          value={formState.processMastery}
          onChange={handleChange}
          info={t("expertForm.processMasteryInfo")}
          minRows={1}
          error={!!validationErrors.processMastery}
          helperText={validationErrors.processMastery}
        />
      </Paper>
    </Grid>
  );
};

export default SkillsAndAbilities;
